// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.11.0",
  date: "2026-10-05T07:54:00.061Z",
  gitInfo: {
    dirty: false,
    raw: "66593614a",
    hash: "66593614a",
    distance: null,
    tag: null,
    semver: null,
    suffix: "66593614a",
    semverString: null
  }
};
/* tslint:enable */
